import Stage1Player1Room from "../shared/Stage1Player1Room";

export default function Five_Players_Stage1_Player1(props) {
  return <Stage1Player1Room {...props} playerCount={5} />;
}